export const REPORT_INTRO_COOKIE_KEY = 'report-intro';
export const STICKY_INTRO_COOKIE_KEY = 'sticky-intro';

export type ReportIntroStep = { element?: string | Element; intro?: string };

export const reportIntroSteps: ReportIntroStep[] = [
  {
    element: '[data-testid="report-type-dropdown"]',
    intro: 'Select the type of report you want from this dropdown.'
  },
  {
    element: '[data-testid="report-date-selector"]',
    intro: 'Select the date range for the data to be included in your report here.'
  },
  {
    element: '.research__form__input',
    intro: 'Type your question here. Press Enter to send.'
  },
  {
    element: '.research__form__icon',
    intro: 'Click to send your question or stop a running request.'
  },
  {
    element: '.research__form__followup-box',
    intro: 'Relevant follow-up suggestions will appear here.'
  },
  {
    element: '.research__form__description',
    intro: 'This area describes the selected report type.'
  },
  {
    element: '.conversation-history-wrapper .ui-button',
    intro: 'Open your conversation history to load or delete previous chats.'
  },
  {
    intro: 'That’s it — try asking a question to start the assistant.'
  }
];

export const stickyIntroSteps = [
  {
    element: '.user-message-view__question',
    intro: 'This is your question. When you scroll down, it will stick to the top of the screen so you can always see it.',
    scrollTo: 'off',
  },
  {
    element: '[data-testid="follow-up-questions-button"]',
    intro: 'Click here to view suggested follow-up questions related to your report.',
    scrollTo: 'off',
  },
  {
    element: '[data-testid="explore-charts-button"]',
    intro: 'Click here to explore charts based on your report data.',
    scrollTo: 'off',
  },
  {
    element: '[data-testid="share-button"]',
    intro: 'Click here to share your report with others.',
    scrollTo: 'off',
  },
  {
    element: '[data-testid="sources-button"]',
    intro: 'Click here to view the sources of your report data.',
    scrollTo: 'off',
  },
  {
    element: '[data-testid="expand-results-button"]',
    intro: 'Click here to expand the results area for a better view of your report.',
    scrollTo: 'off',
  },
  {
    intro: 'That\'s it - enjoy new experiences while exploring your report!',
    scrollTo: 'off',
  }
];

export default reportIntroSteps;
